// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyV1PharmacyBiRequestSearchDefaultResponseData {
    static getAttributeTypeMap() {
        return PharmacyV1PharmacyBiRequestSearchDefaultResponseData.attributeTypeMap;
    }
}
PharmacyV1PharmacyBiRequestSearchDefaultResponseData.discriminator = undefined;
PharmacyV1PharmacyBiRequestSearchDefaultResponseData.additionalProperties = false;
PharmacyV1PharmacyBiRequestSearchDefaultResponseData.attributeTypeMap = [
    {
        "name": "requests",
        "baseName": "requests",
        "type": ""
    },
];
//# sourceMappingURL=pharmacyV1PharmacyBiRequestSearchDefaultResponseData.js.map